/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var moyaToggle = MoyaContainer.get('core.toggle');
    MoyaComponents.register('site.dropdown', function (el) {
        console.log(el);
        moyaToggle.create(el.querySelector('button'), el.querySelector('.dropdown__links'), el.dataset.key, {
            closeOthers: true,
            onOpen: function () {
                //others: remove aria-expanded=true!
                document.querySelectorAll('button[aria-expanded="true"]').forEach(function (button) {
                    if (button.parentElement.dataset.key !== el.dataset.key) {
                        button.setAttribute('aria-expanded', "false");
                    }
                });
            }
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
